import axios from "axios";
// ----------------------------------------------------------------------

const baseURL = "https://api.immaculeeparyaj.com";

const axiosInstance = axios.create({
  baseURL,
  // baseURL: 'http://127.0.0.1:8000',
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
